import styled from 'styled-components';

export const PasswordFormContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${(props) => props.theme.colors.midnight7};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
`;

export const PasswordFormContent = styled.div`
  width: 100%;
  max-width: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Logo = styled.img`
  height: 32px;
  margin-bottom: 48px;
`;

export const FormCard = styled.div`
  background-color: ${(props) => props.theme.colors.midnight7};
  border-radius: 8px;
  padding: 48px;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  @media (max-width: ${(props) => props.theme.size.mobileL}) {
    padding: 32px 24px;
  }
`;

export const Title = styled.h1`
  color: ${(props) => props.theme.colors.white};
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 12px 0;
  text-align: center;
`;

export const Description = styled.p`
  color: ${(props) => props.theme.colors.gray3};
  font-size: 16px;
  margin: 0 0 24px 0;
  text-align: center;
  line-height: 1.5;
`;

export const ErrorMessage = styled.div`
  background-color: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #ef4444;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
  text-align: center;
  animation: shake 0.4s ease-in-out;

  @keyframes shake {
    0%,
    100% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(-8px);
    }
    75% {
      transform: translateX(8px);
    }
  }
`;

export const PasswordInput = styled.input`
  width: 100%;
  padding: 14px 16px;
  font-size: 16px;
  border: 2px solid ${(props) => props.theme.colors.midnight4};
  border-radius: 6px;
  background-color: ${(props) => props.theme.colors.midnight7};
  color: ${(props) => props.theme.colors.white};
  margin-bottom: 16px;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.teal1};
  }

  &::placeholder {
    color: ${(props) => props.theme.colors.gray5};
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 600;
  background-color: ${(props) => props.theme.colors.teal1};
  color: ${(props) => props.theme.colors.midnight7};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;

  &:hover {
    background-color: ${(props) => props.theme.colors.teal2};
  }

  &:active {
    transform: translateY(1px);
  }
`;
